import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { List } from 'immutable';
import BlockTypes from '../../../types/BlockTypes';
export default function makeSelectTableCellRange(store) {
  return {
    selectTableCellRange: function selectTableCellRange(editor, _ref) {
      var givenStartCell = _ref.start,
          endCell = _ref.end;
      var expandSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var tableId = endCell.getIn(['data', 'tableId']);
      var previous = store.getItem(tableId) || {};
      var startCell = [givenStartCell, editor.value.focusBlock, previous.startCell, endCell].find(function (candidate) {
        return candidate && candidate.type === BlockTypes.TABLE_CELL;
      });
      var selectedCellKeys = expandSelection && previous.selectedCellKeys || new List();
      var selectedCellsCoords = expandSelection && previous.selectedCellsCoords || new List();

      var _editor$getCellsCoord = editor.getCellsCoords([startCell, endCell]),
          _editor$getCellsCoord2 = _slicedToArray(_editor$getCellsCoord, 2),
          startCoords = _editor$getCellsCoord2[0],
          endCoords = _editor$getCellsCoord2[1];

      for (var i = Math.min(startCoords[0], endCoords[0]); i <= Math.max(startCoords[0], endCoords[0]); i++) {
        for (var j = Math.min(startCoords[1], endCoords[1]); j <= Math.max(startCoords[1], endCoords[1]); j++) {
          selectedCellsCoords = selectedCellsCoords.push([i, j]);
        }
      }

      store.updateItem(store.getItem('lastFocusedTableId'), {});
      store.updateItem('lastFocusedTableId', tableId);
      store.updateItem(tableId, {
        startCell: startCell,
        endCell: endCell,
        selectedCellKeys: selectedCellKeys.push(startCell.key).push(endCell.key),
        selectedCellsCoords: selectedCellsCoords
      });
      return editor.snapshotSelection().withoutSaving(function () {
        return editor.deselect();
      });
    }
  };
}